import { Subject } from 'rxjs';

export interface BaseEntity<ID = number> {
  id: ID;
  created_at: any;
  deleted_at: any;
  updated_at: any;
}

export interface MenuItem<T = any> {
  name: string;
  permission?: string | string[];
  method?: (item?: T) => void;
  disabled?: (item?: T) => boolean;
  hidden?: (item?: T) => boolean;
  link?: (item?: T) => unknown;
  divider?: boolean;
  group?: string; // Group name if at least one item in group is visible it will have divider: true
  icon?: MenuItemIconConfig;
  icons?: MenuItemIconConfig[];
}

export interface ActionEntity {
  actionName?: string;
  name: string;
  capitalizeName?: boolean;
  disabled?: boolean | ((id) => boolean);
  icon?: string;
  callback?: (...params) => any;
}

export enum ManageMode {
  ADD = 'add',
  EDIT = 'edit',
  DUPLICATE = 'duplicate',
  BULK_EDIT = 'bulk-edit',
  DELETE = 'delete',
  BULK_DELETE = 'bulk-delete',
}

export interface Timezone {
  identifier: string;
  utc_offset: string;
  combined_info: string;
}

export type ManagerDialogData<T, I = T, E = any> = {
  mode: ManageMode;
  item?: T;
  onSubmit?: (value: Partial<I>) => Subject<void>;
  extras?: E;
  snackbarMessageCallback?: () => string;
};

export enum ApplicationName {
  Nexus = 'nexus',
  Itracker = 'itracker',
  Reporting = 'reporting',
}

export enum DateType {
  SQL = 'sql',
  ISO = 'iso',
}

export type GraphQLResponse = BaseGraphQLBody & GraphQLErrors;

export type BaseGraphQLBody = {
  query: string;
  operationName: string;
  variables: any;
};

export type GraphQLErrors = { errors: GraphQLError[] };

export type GraphQLError = {
  message: string;
  extensions?: {
    validation?: {
      [key: string]: string[];
    };
  };
};

export type GraphQLResultExtension = {
  extensions: { lighthouse_subscriptions: { channel: string } };
};

export enum MenuItemIconPosition {
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
}

export type MenuItemIconConfig = {
  name: string;
  position: MenuItemIconPosition;
  className?: string;
};

export enum BadgeSize {
  X_SMALL = 'x-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type SizeDefinition = {
  [key in BadgeSize]: {
    size: number;
    fontSize: number;
  };
};

export type ColorMap = {
  bgColor: string;
  textColor: string;
  swatchColor: string;
  tickColor: string;
};
